<template>
    <component @mouseover="hovered = true" @mouseleave="hovered = false" :is="tag">
        {{ displaying }}
    </component>
</template>

<script>
export default {
    name: "HoverText",
    props: {
        tag: {
            type: String,
            default: 'p'
        },
        default: {
            type: String,
            default: ''
        },
        hover: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            hovered: false
        }
    },
    computed: {
        displaying () {
            return this.hovered ? this.hover : this.default;
        }
    }
}
</script>